// Lightweight Scroll Animations using Intersection Observer
(function() {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    return; // Skip animations if user prefers reduced motion
  }

  // Check if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    return; // Fallback: no animations if not supported
  }

  // Animation configuration
  const animationConfig = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  // Create Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Unobserve after animation to improve performance
        observer.unobserve(entry.target);
      }
    });
  }, animationConfig);

  // Helper function to check if element should be excluded
  function shouldExcludeElement(element) {
    // Exclude footer and header elements
    if (element.closest('footer, .footer, header, .header, .section-header')) {
      return true;
    }
    
    // Exclude SVG icons
    if (element.tagName === 'svg' || element.closest('svg')) {
      return true;
    }
    
    // Exclude icons
    if (element.classList.contains('icon') || element.closest('.icon')) {
      return true;
    }
    
    // Exclude payment and social icons
    if (element.closest('.list-payment, .list-social, .footer__payment')) {
      return true;
    }
    
    // Exclude elements with no-animate class
    if (element.classList.contains('no-animate') || element.closest('.no-animate')) {
      return true;
    }
    
    return false;
  }

  // Function to initialize animations
  function initScrollAnimations() {
    // Select elements to animate
    const selectors = [
      '.title-wrapper',
      'h1:not(footer h1, .footer h1, header h1, .header h1)',
      'h2:not(footer h2, .footer h2, header h2, .header h2)',
      'h3:not(footer h3, .footer h3, header h3, .header h3)',
      'h4:not(footer h4, .footer h4, header h4, .header h4)',
      '.text-body:not(footer .text-body, .footer .text-body)',
      'p:not(footer p, .footer p, header p, .header p)',
      '.subtitle:not(footer .subtitle, .footer .subtitle)',
      '.caption:not(footer .caption, .footer .caption)',
      '.grid__item:not(footer .grid__item, .footer .grid__item)',
      '.button:not(footer .button, .footer .button, header .button, .header .button)',
      'a.button:not(footer a.button, .footer a.button)',
      '.field:not(footer .field, .footer .field)',
      '.select:not(footer .select, .footer .select)',
      '.media:not(footer .media, .footer .media)',
      'img:not(footer img, .footer img, header img, .header img, svg img, .icon img)',
      '.badge:not(footer .badge, .footer .badge)',
      '.link:not(footer .link, .footer .link, header .link, .header .link)',
      'blockquote:not(footer blockquote, .footer blockquote)',
      'ul:not(footer ul, .footer ul, header ul, .header ul)',
      'ol:not(footer ol, .footer ol)',
      'li:not(footer li, .footer li, header li, .header li)',
      'hr:not(footer hr, .footer hr)',
      'section.section:not(footer section, .footer section, header section, .header section)'
    ];

    // Observe all matching elements
    selectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (!shouldExcludeElement(element) && !element.classList.contains('is-visible')) {
            element.classList.add('scroll-animate');
            observer.observe(element);
          }
        });
      } catch (e) {
        // Skip invalid selectors
        console.warn('Invalid selector:', selector);
      }
    });

    // Handle grid items with stagger effect
    document.querySelectorAll('.grid:not(footer .grid, .footer .grid, header .grid, .header .grid)').forEach(grid => {
      if (shouldExcludeElement(grid)) return;
      
      const items = Array.from(grid.querySelectorAll('.grid__item')).filter(item => !shouldExcludeElement(item));
      items.forEach((item, index) => {
        if (!item.classList.contains('is-visible')) {
          item.classList.add('scroll-animate', 'scroll-animate-stagger');
          item.style.setProperty('--stagger-delay', `${index * 0.1}s`);
          observer.observe(item);
        }
      });
    });

    // Handle list items with stagger
    document.querySelectorAll('ul:not(footer ul, .footer ul, header ul, .header ul), ol:not(footer ol, .footer ol)').forEach(list => {
      if (shouldExcludeElement(list)) return;
      
      const items = Array.from(list.querySelectorAll('li')).filter(item => !shouldExcludeElement(item));
      items.forEach((item, index) => {
        if (!item.classList.contains('is-visible')) {
          item.classList.add('scroll-animate', 'scroll-animate-stagger');
          item.style.setProperty('--stagger-delay', `${index * 0.1}s`);
          observer.observe(item);
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  // Re-initialize for Shopify theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(initScrollAnimations, 100);
    });
  }
})();

